import { Flex } from "@chakra-ui/react";
import { DisplayRecipients as EmailDisplayRecipients } from "features/Resources/Email/Components/DisplayRecipients";
import { DisplayRecipients as MessageDisplayRecipients } from "features/Resources/MessageTemplate/Components/DisplayRecipients";
import { DisplayAssignee } from "features/Resources/TaskTemplate/Components/DisplayAssignee";
import { TemplateSummary } from "features/Resources/SharedTemplate/models";
import { DisplayTemplateAttendeesColumn } from "features/Resources/MeetingTemplate/Components/DisplayTemplateAttendees";
import RecordTargetTag from "features/RecordTarget/RecordTargetTag";
import ResourceTargetAvatar from "features/Resources/SharedTemplate/Components/ResourceTargetAvatar";
import DisplayResourceTargetsColumn from "features/Resources/SharedTemplate/Components/DisplayResourceTargetsColumn";
import useTargetName from "hooks/useTargetName";
import { RecordTarget } from "features/RecordTarget/models";

function CheckpointRecipientAvatar({ recipient }: { recipient: RecordTarget }) {
  const { name, role } = useTargetName({
    resourceId: recipient.targetId,
    resourceType: recipient.targetType,
  });
  return <ResourceTargetAvatar name={name || ""} roleName={role} />;
}

export function DisplayCheckpointRecipients({ recipients }: { recipients: RecordTarget[] }) {
  if (!recipients?.length) return null;

  return (
    <Flex align="center" gap="1">
      <DisplayResourceTargetsColumn<RecordTarget>
        items={recipients}
        renderTag={(recipient: RecordTarget) => (
          <RecordTargetTag key={recipient.targetId} recordTarget={recipient} disabled />
        )}
        renderAvatar={(recipient: RecordTarget) => <CheckpointRecipientAvatar recipient={recipient} />}
        getKey={(recipient: RecordTarget) => recipient.targetId}
        emptyLabel="No Recipients"
      />
    </Flex>
  );
}

export function DisplayTemplateRecipients({ template }: { template: TemplateSummary }) {
  switch (template?.templateType) {
    case "email_template":
      return <EmailDisplayRecipients email={template.template} />;
    case "task_template":
      return <DisplayAssignee taskTemplate={template.template} />;
    case "message_template":
      return <MessageDisplayRecipients messageTemplate={template.template} />;
    case "meeting_template":
      return <DisplayTemplateAttendeesColumn meetingTemplateId={template?.template?.id} />;
    case "checkpoint_template":
      return <DisplayCheckpointRecipients recipients={template?.template?.recipients} />;
    default:
      return null;
  }
}
